import React, { useEffect } from "react";
import { addDestination } from "../../apis/firebase";
import { DestinationType } from "../../constants";
import { showAlertPopUp } from "../utils/Overlay";

interface TwitterOAuthParams {
  oauth_token: string;
  oauth_verifier: string;
}

function getParams() {
  let queryDict = {};
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      queryDict[item.split("=")[0]] = item.split("=")[1];
    });
  return queryDict;
}

export function getTwitterOAuthProcessParams(): TwitterOAuthParams | null {
  const params = getParams() as TwitterOAuthParams;
  if (params) {
    if (params.oauth_token && params.oauth_verifier) {
      return params;
    }
  }
  return null;
}

export async function handleTwitterOAuth(
  user: User,
  params: TwitterOAuthParams
): Promise<{ twitterData: Object; destination: Destination }> {
  const { oauth_token, oauth_verifier } = params;
  const res = await fetch(`/api/tat?t=${oauth_token}&v=${oauth_verifier}`);
  const data = await res.json();
  if (res.status === 200) {
    const newDestination = await addDestination(
      user,
      DestinationType.TWITTER,
      data,
      {
        handle: data.screen_name,
      }
    );
    return { twitterData: data, destination: newDestination };
  } else {
    throw new Error(data.error);
  }
}

export async function addTwitterDestination(onError: Function) {
  try {
    const resRT = await fetch(
      `/api/trt?callback=${encodeURIComponent(location.href)}`
    );
    if (resRT.status === 200) {
      const { token } = await resRT.json();
      // @ts-ignore
      window.location = `https://api.twitter.com/oauth/authorize?oauth_token=${token}`;
    } else {
      showAlertPopUp(`There is a problem connecting to Twitter.`);
    }
  } catch (err) {
    onError([
      err.message || "Error adding Twitter destination.",
      "/help/twitter",
    ]);
  }
}

export function formatTwitterSuccessMessage(data) {
  return (
    <span>
      Twitter account{" "}
      {data && data.screen_name ? (
        <TwitterLink handle={data.screen_name} />
      ) : (
        ""
      )}{" "}
      linked successfully.
    </span>
  );
}

export function TwitterLink({ handle }: { handle: string }) {
  return (
    <a href={`https://twitter.com/${handle}`} target="_blank">
      @{handle}
    </a>
  );
}
